import { notificationService } from '@/notifications';
import type { PlatformEvent } from '@/platform/events/EventModels';
import { subscribeToPlatformEvents } from '@/platform/events/EventSubscriber';

function shouldNotify(event: PlatformEvent): boolean {
  return (
    event.severity === 'high' ||
    event.severity === 'critical' ||
    event.category === 'security'
  );
}

export function registerNotificationPublisher(): () => void {
  return subscribeToPlatformEvents((event) => {
    if (!shouldNotify(event)) {
      return;
    }

    void notificationService.publish({
      title: `${event.resource} ${event.type.replace(/_/g, ' ')}`,
      message: event.details,
      productId: event.product.toLowerCase().replace(/\s+/g, '-'),
      category: 'audit',
      type: 'critical',
      severity: event.severity === 'critical' ? 'critical' : 'warning',
      productName: event.product,
      metadata: {
        category: event.category,
        eventType: event.type,
        correlationId: event.correlationId ?? '',
      },
    });
  });
}
